/**
 * いま提出の流れ（画面）が持っている送信待ちの提出の id。
 * 圏外から戻って background の flush が送れたとき、流れの画面が開いていればそちらが結果を出す。
 * タブ側の outbox.settled の受け口は、ここに入っている id を飛ばす（結果の二重表示を防ぐ）。
 */
const owned = new Set<string>();
let activeFlows = 0;
const idleWaiters: Array<() => void> = [];

export function claimItem(id: string): void {
  owned.add(id);
}
export function releaseItem(id: string): void {
  owned.delete(id);
}
export function isOwnedByFlow(id: string): boolean {
  return owned.has(id);
}

export function flowStarted(): void {
  activeFlows++;
}
export function flowEnded(): void {
  activeFlows = Math.max(0, activeFlows - 1);
  if (activeFlows === 0) for (const w of idleWaiters.splice(0)) w();
}
/** 提出の流れが開いていなければすぐ、開いていれば閉じるまで待つ（遅れて届いた結果のダイスを重ねないため） */
export function whenFlowIdle(): Promise<void> {
  return activeFlows === 0 ? Promise.resolve() : new Promise((r) => idleWaiters.push(r));
}
